import axios from "axios";

const API_URL = window._env_?.ERP_API_BASE_URL || process.env.REACT_APP_API_URL;

const instance = axios.create({
    baseURL: API_URL,
})

const setToken = (token = "") => {
    if (token) {
        return instance.defaults.headers.authorization = `Bearer ${token}`;
    }
    instance.defaults.headers.authorization = "";
}

export const login = async (data) => {
    const { data: result } = await instance.post("/auth/login/", data);
    setToken(result.token);
    return result;
}

export const logout = async () => {
    const { data: result } = await instance.get("/auth/logout/");
    setToken("");
    return result;
}

export const getCurrent = async (token) => {
    try {
        setToken(token);
        const { data: result } = await instance.get("/auth/current/");
        return result;
    } catch (error) {
        setToken("");
        throw error;
    }
}

export default instance;
